module.exports = __webpack_public_path__ + "img/section3-img1.9853f52b.png";